import { render } from "./MenuOverlayPage.vue?vue&type=template&id=6782af71&scoped=true"
import script from "./MenuOverlayPage.vue?vue&type=script&lang=js"
export * from "./MenuOverlayPage.vue?vue&type=script&lang=js"

import "./MenuOverlayPage.vue?vue&type=style&index=0&id=6782af71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6782af71"]])

export default __exports__